<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="活动总结" prop="summarize">
              <VueEditor
              id="editor"
             
              v-model="form.summarize"
              useCustomImageHandler
              @image-added="handelRichTextImageAdded"
            ></VueEditor>
            </el-form-item>
          </el-col>

         
        </el-row>
      </el-form>
    </div>
    <div style="text-align: right" >
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        提交
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
  <script>
import {activeSummarize} from "@/api/goldHousekeep/index"
import { putFile } from '@/api/crmedical/contract/add';
export default {
  components: {},
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
     

      form: {
        id: '',
        summarize: '',
      },
      formRules: {
        summarize: [{ required: true, message: '活动总结不能为空', trigger: 'change' }],
       
      },
     
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
   
    handelRichTextImageAdded(file, Editor, cursorLocation, resetUploader) {
      
      var formData = new FormData();
      formData.append('file', file);
      // 通过上传接口返回url，将url放入富文本编辑器中
      putFile(formData)
        .then((res) => {
          let url = res.data.link;
          Editor.insertEmbed(cursorLocation, 'image', url);
          resetUploader();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async initData() {
      this.form.id =this.row.id
      this.form.summarize =this.row.summarize
    },
    saveRecord() {
      
    
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            activeSummarize(this.form).then((res) => {
              this.$message.success('提交成功');
              this.$emit('success');
            });
          }
        });
     
      
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
  <style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
  